import { getParameterByName, updateURLParameter } from "helpers/utils";
import React from "react";

const { Grid, TextField, Box } = require("@material-ui/core");

export function DateRangeFilter({
  locationSearch,
  setLocationSearch,
  rangeProps,
  fromLabel,
  toLabel,
  fromFilterKey,
  toFilterKey,
}) {
  const handleChange = (prop) => (e) => {
    const value = e.target.value || "";
    const search = updateURLParameter(locationSearch, prop, value);
    setLocationSearch(search);
  };

  return (
    <Grid container spacing={8}>
      <Grid item xs={6}>
        <TextField
          variant="standard"
          margin="normal"
          label={fromLabel}
          value={getParameterByName(fromFilterKey, locationSearch) || ""}
          onChange={handleChange(fromFilterKey)}
          fullWidth
          style={{
            input: {
              color: "#fff !Important",
              "&::placeholder": {
                opacity: 1,
              },
            },
            label: { color: "#8c8c8c" },
          }}
          type="date"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          variant="standard"
          fullWidth
          margin="normal"
          label={toLabel}
          value={getParameterByName(toFilterKey, locationSearch) || ""}
          onChange={handleChange(toFilterKey)}
          type="date"
          style={{
            input: {
              color: "#fff !Important",
              "&::placeholder": {
                opacity: 1,
              },
            },
            label: { color: "#8c8c8c" },
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
    </Grid>
  );
}
